export default __webpack_public_path__ + "media/images/cleardot-e5634ce393b9b3dfb4ee4f2973de3692.gif";